import React, { useState, useEffect } from 'react';
import Header from '../components/header';
import Footer from '../components/footer';
import FloatingChatButton from '../components/FloatingChatButton';
import ContactForm from '../components/ContactForm';
import BlogsCarousel from '../components/BlogsCarousel';
import CaseStudiesCarousel from '../components/CaseStudiesCarousel';
import { Link, useNavigate } from 'react-router-dom';
import TestimonialVideoCarousel from '../components/TestimonialVideoCarousel';

const blogs = [
  {
    title: "Parkinson's Disease and Its Cure with CyberKnife",
    image: "/images/image copy 43.png",
    link: "#",
  },
  {
    title: "Cancer and Relapse Prevention",
    image: "/images/image copy 44.png",
    link: "#",
  },
  {
    title: "Is Dairy Fueling Your Autoimmune Flare-Ups? The Science Explained",
    image: "/images/image copy 45.png",
    link: "#",
  },
  {
    title: "Managing PCOS Naturally: Diet, Exercise & Hormonal Balance",
    image: "/images/image copy 46.png",
    link: "#",
  },
  {
    title: "Adoption vs. Surrogacy: Which Path Is Right for You?",
    image: "/images/image copy 47.png",
    link: "/blogs/adoption-vs-surrogacy-which-path-is-right-for-you",
  },
  {
    title: "Chronic Acidity: What your Stomach is Trying to Tell You",
    image: "/images/image copy 48.png",
    link: "/blogs/chronic-acidity-what-your-stomach-is-trying-to-tell-you",
  },
  {
    title: "Bone Marrow Transplant: What to Expect Before, During, and After",
    image: "/images/image copy 49.png",
    link: "/blogs/bone-marrow-transplant-what-to-expect-before-during-and-after",
  },
  {
    title: "Stem Cell Banking: Why It’s a Gift for Your Child’s Future Health",
    image: "/images/image copy 50.png",
    link: "/blogs/stem-cell-banking-why-it-s-a-gift-for-your-child-s-future-health",
  },
];

const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://medical-linkers.onrender.com';

const CARDS_PER_PAGE = 1; // Changed to slide one by one

const KnowledgeCenter = () => {
  const [caseStudies, setCaseStudies] = useState([]);
  const [caseStudyStartIdx, setCaseStudyStartIdx] = useState(0);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    fetchCaseStudies();
  }, []);

  const fetchCaseStudies = async () => {
    try {
      setLoading(true);
      const response = await fetch(`${API_BASE_URL}/api/case-studies?status=published&limit=8`);
      
      if (!response.ok) {
        throw new Error('Failed to fetch case studies');
      }
      
      const data = await response.json();
      setCaseStudies(data.caseStudies || []);
    } catch (error) {
      console.error('Error fetching case studies:', error);
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };

  // Case Studies carousel functions
  const handleCaseStudyNext = () => {
    if (caseStudies.length > 0) {
      setCaseStudyStartIdx((prev) => (prev + 1) % caseStudies.length);
    }
  };

  const handleCaseStudyPrev = () => {
    if (caseStudies.length > 0) {
      setCaseStudyStartIdx((prev) => (prev - 1 + caseStudies.length) % caseStudies.length);
    }
  };

  // Show 4 case studies at a time, starting from caseStudyStartIdx
  const getVisibleCaseStudies = () => {
    if (caseStudies.length === 0) return [];
    
    const visibleCaseStudies = [];
    for (let i = 0; i < Math.min(4, caseStudies.length); i++) {
      const index = (caseStudyStartIdx + i) % caseStudies.length;
      visibleCaseStudies.push(caseStudies[index]);
    }
    return visibleCaseStudies;
  };

  // Carousel state for sliding effect
  const [videoIndex, setVideoIndex] = useState(0);
  const videoCards = [
    {
      title: 'The Blog Name can be long, and can come in two to three lines',
      link: '#',
    },
    {
      title: 'The Blog Name can be long, and can come in two to three lines',
      link: '#',
    },
    {
      title: 'The Blog Name can be long, and can come in two to three lines',
      link: '#',
    },
    {
      title: 'Another Blog Name for Video',
      link: '#',
    },
    {
      title: 'Yet Another Video Blog',
      link: '#',
    },
    {
      title: 'A Sixth Video Blog Example',
      link: '#',
    },
  ];
  const VIDEOS_PER_PAGE = 3;
  const maxVideoIndex = videoCards.length - VIDEOS_PER_PAGE; // Max index is 3 (showing cards 3,4,5)

  return (
    <div className="min-h-screen flex flex-col bg-white">
      <Header />
      <main className="flex-grow">
        <section className="container mx-auto px-4 py-12">
          <h1 className="text-5xl font-bold text-center mb-2">
            <span className="text-[#1976f2]">Knowledge</span> Centre
          </h1>
          <p className="text-center text-gray-600 mb-8 max-w-2xl mx-auto">
            Know the best practices and treatments available on the globe.
          </p>

          {/* Newsletter Banner */}
          <div className="bg-[#1976f2] text-white rounded-lg flex flex-col md:flex-row items-center justify-between px-6 py-6 mb-12">
            <div className="text-lg font-semibold mb-4 md:mb-0">Subscribe to our monthly newsletter</div>
            <div className="flex items-center w-full md:w-auto">
              <input type="email" placeholder="Your email" className="rounded px-4 py-2 text-gray-800 w-full md:w-64 mr-2" />
              <button className="bg-white text-[#1976f2] font-bold px-6 py-2 rounded">Subscribe</button>
            </div>
            <div className="text-xs text-white mt-2 md:mt-0 md:ml-6">Stay updated about latest updates in medical treatments from around the world</div>
          </div>

          {/* Recent Blogs Section */}
          <BlogsCarousel title="Recent Blogs" limit={8} showNavButtons={true} />
        </section>
      </main>
      {/* Get Treated Contact Form Section */}
      <section className="container mx-auto px-4 py-16">
        <div className="flex flex-col md:flex-row items-center bg-white rounded-lg overflow-hidden shadow-lg">
          <div className="md:w-1/2 p-8">
            <h2 className="text-3xl font-bold mb-2">Get treated at preferred hospital</h2>
            <p className="text-gray-600 mb-6">Start your treatment journey now</p>
            <ContactForm formType="knowledge-center" />
          </div>
          <div className="md:w-1/2">
            <img
              src="/images/image copy 22.png"
              alt="Medical Professional"
              className="w-full h-full object-cover"
            />
          </div>
        </div>
      </section>
      {/* Case Studies Section */}
      <section className="container mx-auto px-4 pt-12 pb-4">
        <h2 className="text-5xl font-bold text-center mb-8">
          <span className="text-[#1976f2]">Case</span> Studies
        </h2>
        <CaseStudiesCarousel title="Latest Case Studies" limit={8} showNavButtons={true} />

        {/* All Case Studies Button - restore original styling */}
        <div className="flex justify-center mb-8">
          <Link 
            to="/case-study"
            className="bg-[#1976f2] text-white px-8 py-3 rounded-full font-semibold hover:bg-[#125ea2] transition-colors text-lg shadow-lg"
          >
            All Case Studies
          </Link>
        </div>
      </section>
      {/* Recent Videos Section (Carousel) */}
      <TestimonialVideoCarousel />
      <Footer />
      <FloatingChatButton />
    </div>
  );
};

export default KnowledgeCenter;

